import React, {Fragment, useEffect, useState} from 'react'
import {getStore} from "../dashboard/actions";
import {connect} from 'react-redux';
import _ from "lodash";
import SettingsForm from "./SettingsForm";
import {editStore} from "./actions";

const Settings = (props) => {

    useEffect(() => {
        props.getStore();
    }, []);

    const {store, postStoreResult} = props ;
    const [renderForm , setRenderForm] = useState(false) ;
    const [storeInitialValues, setStoreInitialValues] = useState({});
    const [loading , setLoading] = useState(false) ;
    const [postStoreResultMessage, setPostStoreResultMessage] = useState(null) ;

    useEffect(() => {
        if (!_.isEmpty(store)) {
            setStoreInitialValues(store) ;
            setRenderForm(true) ;
        }
    } , [store]);

    useEffect(() => {
        if (!_.isEmpty(postStoreResult)) {
            setLoading(false) ;
            if (postStoreResult.isSuccess) {
                setPostStoreResultMessage({success : true, message : postStoreResult.message}) ;
            }
            else {
                setPostStoreResultMessage({success : false, message : postStoreResult.message}) ;
            }
        }
    }, [postStoreResult]);

    const submit = (values) => {
        setLoading(true);
        props.editStore(values);
    };

    return (
        <Fragment>
            <div className="maximumSizeHandler">
                <div className="contentTitle">
                    <span className=" font-size_24 boldFont middleContext">اطلاعات پایه</span>
                </div>
            </div>
            <span className="lineSeparator"></span>
            {renderForm? <SettingsForm onSubmit={submit} initialValues={storeInitialValues} loading={loading} /> : null}
        </Fragment>
    );

};

const mapStateToProps = ({store, postStoreResult}) => ({
    store,
    postStoreResult
});

export default connect(mapStateToProps, {getStore, editStore})(Settings);
